module.exports = __webpack_public_path__ + "assets/img/fee2-bw.svg";